import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FloorRowPercentage from "../components/FloorRowPercentage";
import FloorRowIcon from "../components/FloorRowIcon";
import ForgeViewer from "../components/ForgeViewer";
import { functions } from "../constants/common-functions";
import { colorFunctions } from "../constants/colors";

export default function FloorRow({ id, name, facilityId }) {
  const [areaDisplay, setAreaDisplay] = useState("");
  const [totalArea, setTotalArea] = useState(0);
  const [areaItems, setAreaItems] = useState([]);

  const [popupContent, setPopupContent] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const URN =
    "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLnhEM0hlVU5kUjFhRWFnc0RKSnQ1d1E_dmVyc2lvbj0x";

  useEffect(() => {
    functions.getArrayFromAjax(
      "/resolutionsoftwareplatform/floorgetspaces?floorId=" + id,
      null,
      populateSpaces
    );
  }, [id]);

  useEffect(() => {
    if (totalArea > 0) {
      functions.getArrayFromAjax(
        "/resolutionsoftwareplatform/floorgettotalareabyspacetype?facilityId=" +
          facilityId +
          "&floorId=" +
          id,
        null,
        populateAreas
      );
    }
  }, [totalArea]);

  const populateSpaces = (input) => {
    let area = 0;
    for (let i = 0; i < input.length; i++) {
      area += parseInt(input[i].areaReportable);
    }
    setTotalArea(area);
    setAreaDisplay(functions.formatNumber(area, 0));
  };

  const populateAreas = (input) => {
    let tempAreas = [];

    for (let i = 0; i < input.length; i++) {
      let areaPercentage = Math.round((100 * input[i].value) / totalArea);

      tempAreas.push({
        id: input[i].id,
        name: input[i].name,
        area: functions.formatNumber(input[i].value, 1),
        areaPercentage: areaPercentage,
        color: colorFunctions.generateColorForIndex(i),
        isFirst: i === 0,
        isLast: i === input.length - 1,
      });
    }

    setAreaItems(tempAreas);
  };

  // -------------------------------
  //      POPUP HANDLERS
  // -------------------------------

  const openPopup = (content) => {
    setPopupContent(content);
    setShowPopup(true);
  };

  const closePopup = () => {
    setPopupContent(null);
    setShowPopup(false);
  };

  const isLocal = functions.getIsDemoSystem();

  const goScan = () => {
    if (!isLocal) return;

    openPopup(
      <iframe
        src="https://tour.giraffe360.com/473d82e5fe7c4e6ab64367a0f8e4a43e"
        style={{ width: "100%", height: "100%", border: "none" }}
        title="scan"
      />
    );
  };

  const goPdf = () => {
    if (!isLocal) return;

    openPopup(
      <iframe
        src="../FLOOR00.png"
        style={{ width: "100%", height: "100%", border: "none" }}
        title="pdf"
      />
    );
  };

  const goDwg = () => {
    if (!isLocal) return;

    openPopup(
      <ForgeViewer
        urn={URN}
        viewerLeft="0px"
        viewerRight="0px"
        viewerZIndex="1000"
        viewerTop="0px"
        viewerBottom="0px"
      />
    );
  };


  const buttons = [
    { icon: "camera", click: goScan },
    { icon: "file", click: goPdf },
    { icon: "map", click: goDwg },
  ];

  // -------------------------------
  //          STYLES
  // -------------------------------

  const container = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 22px",
    marginBottom: "14px",
    width: "calc(100% - 80px)",
    background: "linear-gradient(180deg, #ffffff 0%, #f3f4f6 100%)",
    borderRadius: "12px",
    boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
    border: "1px solid rgba(0,0,0,0.05)",
	marginLeft:'20px'
  };

  const leftContainer = {
    display: "flex",
    flexDirection: "column",
    width: "calc(100% - 200px)",
  };

  const topRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  };

  const floorName = {
    fontSize: "15px",
    fontWeight: 600,
    color: "#2d2d2d",
  };

  const sqmContainer = {
    display: "flex",
    alignItems: "baseline",
    fontWeight: 600,
    color: "#3b3b3b",
  };

  const sqmUnit = {
    fontSize: "11px",
    marginLeft: "4px",
    color: "#777",
  };

  const bottomBar = {
    width: "100%",
    height: "14px",
    background: "linear-gradient(180deg, #e7e7e7 0%, #dcdcdc 100%)",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
  };

  const iconBar = {
    display: "flex",
    gap: "12px",
  };

  const popupOverlay = {
    display: showPopup ? "flex" : "none",
    position: "fixed",
    top: 80,
    left: 50,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.65)",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  };

  const popupBox = {
   	display:"flex",
	margin:'30px',
	width:"calc(100% - 86px)",
	height:"calc(100% - 60px)",
    background: "black",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0 12px 30px rgba(0,0,0,0.4)",
  };

  const closeButton = {
    position: "fixed",
    top: "92px",
    right: "20px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "rgba(0,0,0,0.75)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 3px 8px rgba(0,0,0,0.4)",
	zIndex:'99999'
  };

  // -------------------------------
  //          RENDER
  // -------------------------------

  return (
    <>
      <div style={container}>
        <div style={leftContainer}>
          <div style={topRow}>
            <div style={floorName}>{name}</div>
            <div style={sqmContainer}>
              {areaDisplay}
              <span style={sqmUnit}>SQM</span>
            </div>
          </div>

          <div style={bottomBar}>
            {areaItems.map((item) => (
              <FloorRowPercentage
                key={item.id}
                spaceTypeId={item.id}
                floorId={id}
                area={item.area}
                width={
                  item.areaPercentage < 2
                    ? "8px"
                    : item.areaPercentage + "%"
                }
                color={item.color}
                floorName={name}
                name={item.name}
                isFirst={item.isFirst}
                isLast={item.isLast}
              />
            ))}
          </div>
        </div>

        <div style={iconBar}>
          {buttons.map((btn, i) => (
            <div
              key={i}
              style={{
                width: "38px",
                height: "38px",
                background:
                  "linear-gradient(180deg, #2d2f38 0%, #1b1c21 100%)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                color: "white",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              }}
              onClick={btn.click}
            >
              <FontAwesomeIcon icon={btn.icon} />
            </div>
          ))}
        </div>
      </div>

      {/* POPUP */}
      <div style={popupOverlay}>
        <div style={popupBox}>
          <div style={closeButton} onClick={closePopup}>
            <FontAwesomeIcon icon="times" />
          </div>
          {popupContent}
        </div>
      </div>
    </>
  );
}
